import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JdOptionComponent } from './jd-option.component';
import { JdOptionGroupComponent } from './jd-option-group.component';
import { JdOptionPipe, JdSubOptionPipe } from './jd-option.pipe';
import { JdOptionLiComponent } from './jd-option-li.component';
import { JdSelectComponent } from './jd-select.component';
import { JdSelectTopControlComponent } from './jd-select-top-control.component';
import { JdSelectUnselectableDirective } from './jd-select-unselectable.directive';
import { JdOptionContainerComponent } from './jd-option-container.component';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { JdGridModule } from '../grid/jd-grid.module';
import {JdSpinModule} from "../spin/spin.module";

const EXPORT_DEC = [
  JdOptionComponent,
  JdOptionGroupComponent,
  JdOptionGroupComponent,
  JdSubOptionPipe,
  JdOptionPipe,
  JdOptionLiComponent,
  JdSelectComponent,
  JdSelectTopControlComponent,
  JdSelectUnselectableDirective,
  JdOptionContainerComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,
    JdGridModule,
    JdSpinModule
  ],
  declarations: [...EXPORT_DEC],
  exports: [...EXPORT_DEC]
})
export class JdSelectModule {}
